<template>
    <v-dialog width="500" v-model="isOpenSummaryTeams">
        <v-card class="mx-auto">
            <v-card-title>
                <v-row>
                    <v-col class="d-flex justify-center" cols="12">
                        <h3 class="font-weight-light primary--text">Equipos</h3>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-row dense>
                    <v-col cols="12" md="6" class="d-flex justify-center">
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    dark
                                    outlined
                                    color="primary"
                                    v-on="on"
                                    >{{ 'Mes: ' + formatDate(date) }}
                                    <v-icon rigth>mdi-calendar</v-icon>
                                </v-btn>
                            </template>
                            <v-date-picker
                                color="primary"
                                v-model="date"
                                type="month"
                                no-title
                                scrollable
                            >
                                <v-spacer></v-spacer>
                                <v-btn text color="red" @click="menu = false">
                                    Cerrar
                                </v-btn>
                                <v-btn
                                    depressed
                                    text
                                    color="primary"
                                    @click="
                                        searchNewDate(date);
                                        $refs.menu.save(date);
                                    "
                                >
                                    Guardar
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="6" class="d-flex justify-center">
                        <v-btn
                            depressed
                            @click="openCreate()"
                            color="green darken-2"
                            outlined
                            dark
                            small
                        >
                            Crear Equipo
                            <v-icon right>mdi-table-column-plus-before</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>

                <v-data-table
                    :loading="isLoading"
                    :headers="headers"
                    :items="duttyManagers"
                    class="elevation-0"
                    :search="search"
                    :footer-props="footer_props"
                >
                    <template v-slot:top>
                        <v-text-field
                            v-model="search"
                            label="Buscar"
                            class="mx-4"
                        ></v-text-field>
                    </template>
                    <template v-slot:item.created_on="{ item }">
                        {{ formatDate(item.created_on) }}
                    </template>
                    <template v-slot:item.Actions="{ item }">
                        <v-col md="12">
                            <div class="d-flex flex-row justify-space-between">
                                <v-btn
                                    v-if="hasManagerPermission"
                                    fab
                                    @click="openWatch(item)"
                                    x-small
                                    color="orange"
                                    outlined
                                >
                                    <v-icon> mdi-pen </v-icon>
                                </v-btn>
                                <v-btn
                                    v-if="hasAdminPermission"
                                    class="ml-1"
                                    fab
                                    @click="openDeleteDialog(item)"
                                    x-small
                                    color="red"
                                    outlined
                                >
                                    <v-icon> mdi-delete </v-icon>
                                </v-btn>
                            </div>
                        </v-col>
                    </template>
                </v-data-table>
            </v-card-text>

            <v-card-actions elevation="0" class="justify-end mt-n8">
                <v-btn text color="red" @click="isOpenSummaryTeams = false">
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
        <DeleteDialog />
        <AddTeamDialog />
        <EditTeamDialog :dutty_manager="dutty_manager" />
    </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { clone } from '@/util/libUtil.js';
import AddTeamDialog from '@/components/AreaPersonal/Calculadora/Teams/addTeamDialog.vue';
import EditTeamDialog from '@/components/AreaPersonal/Calculadora/Teams/EditTeamDialog.vue';
import DeleteDialog from '@/components/DeleteDialog/DeleteDialog.vue';

export default {
    data: () => ({
        search: '',
        date: new Date().toISOString().substr(0, 7),
        menu: false,
        modal: false,
        dutty_manager: null,
        headers: [
            {
                text: 'Coordinadores',
                value: 'nombre_completo',
                align: 'start',
            },
            { text: 'Fecha', value: 'created_on', align: 'center' },
            {
                text: 'Acciones',
                value: 'Actions',
                align: 'center',
                width: '10px',
            },
        ],
        footer_props: {
            disableItemsPerPage: true,
            itemsPerPageOptions: [10],
        },
    }),
    components: {
        AddTeamDialog,
        EditTeamDialog,
        DeleteDialog,
    },
    computed: {
        duttyManagers() {
            let filteredTeams = [];
            this.teams.forEach((itemTeam) => {
                if (
                    !filteredTeams.some(
                        (item) => item.id === itemTeam.dutty_manager.id
                    )
                )
                    filteredTeams.push({
                        ...itemTeam.dutty_manager,
                        created_on: itemTeam.created_on,
                    });
            });

            return filteredTeams;
        },
        isOpenSummaryTeams: {
            get() {
                return this.$store.state.areaPersonal.calculadora.teamForm
                    .isOpen;
            },
            set(value) {
                this.$store.commit(
                    'areaPersonal/calculadora/isOpenSummaryTeams',
                    value
                );
            },
        },
        ...mapState('areaPersonal/calculadora', {
            teams: (state) => state.teamForm.teams,
            isLoading: (state) => state.teamForm.isLoading,
            dateActualInmutable: (state) => state.dateActualInmutable,
        }),
        ...mapGetters('login', {
            hasAdminPermission: 'hasAdminPermission',
            hasManagerPermission: 'hasManagerPermission',
        }),
    },
    methods: {
        formatDate(date) {
            return new Date(date).toISOString().substr(0, 7);
        },
        openWatch(item) {
            this.$store.commit('areaPersonal/calculadora/isOpenTeamView', true);
            this.dutty_manager = item;
            this.$store.commit(
                'areaPersonal/calculadora/duttyManagerId',
                item.id
            );
        },
        openCreate() {
            this.$store.commit(
                'areaPersonal/calculadora/isOpenTeamCreate',
                true
            );
        },
        searchNewDate() {
            let params = {
                created_on: this.date,
            };
            if (new Date(this.date) >= this.dateActualInmutable) {
                params = { ...params, is_active: true };
            }
            this.getTeams(params);
        },
        openDeleteDialog(item) {
            let toDeleteTeam = [];

            this.teams.forEach((team) => {
                if (team.dutty_manager.id === item.id)
                    toDeleteTeam.push(team.id);
            });

            let deleteObj = {
                toDeleteId: toDeleteTeam,
                toDeleteType: 'TEAM',
                isOpenDeleteDialog: true,
            };

            this.$store.commit('util/deleteDialog', clone(deleteObj));
        },
        ...mapActions('areaPersonal/calculadora', ['getTeams']),
    },
    watch: {
        isOpenSummaryTeams: {
            immeditate: true,
            handler: function (newValue, oldValue) {
                if (
                    this.hasManagerPermission &&
                    newValue &&
                    !this.teams.length
                ) {
                    let params = {
                        created_on: this.date,
                    };
                    if (new Date(this.date) >= this.dateActualInmutable) {
                        params = { ...params, is_active: true };
                    }
                    this.getTeams(params);
                }
            },
        },
    },
};
</script>








